export const ru = {
    noData: 'Нет данных'
};
